export default [
	{
		id: '1',
		name: 'HTML',
		icon: 'fab fa-5x fa-html5 html-logo-color',
	},
	{
		id: '2',
		name: 'CSS',
		icon: 'fab fa-5x fa-css3-alt has-text-info',
	},
	{
		id: '3',
		name: 'JavaScript',
		icon: 'fab fa-5x fa-js has-text-warning',
	},
	{
		id: '4',
		name: 'ReactJS',
		icon: 'fab fa-5x fa-react has-text-link',
	},

	{
		id: '5',
		name: 'Node.js',
		icon: 'fab fa-5x fa-node-js has-text-succes',
	},
	{
		id: '6',
		name: 'Git',
		icon: 'fab fa-5x fa-git-alt git-logo-color',
	},
	{
		id: '7',
		name: 'GitHub',
		icon: 'fab fa-5x fa-github github-logo-color',
	},
];
